<template>
    <div>
        <button v-if="!loading" type="button" @click="appendDataToModal" class="btn btn-sm btn-dark"
                data-toggle="modal" data-target="#description_modal">
            <span>{{ $t('label.description') }}</span>

        </button>
        <span v-else class="spinner-border spinner-border-sm"></span>
        <div>
            <div id="description_modal" class="modal fade rtl" role="dialog">
                <div class="modal-dialog">
                    <div class="modal-content">
                        <div class="modal-header">
                            <div id="title">
                            </div>
                            <button type="button" class="close float-right mr-0" data-dismiss="modal">&times;</button>
                        </div>
                        <div style="display: none" id="data_sheet" class="modal-body mb-4">
                            <table class="table table-hover">
                                <thead id="table-header">
                                <tr>
                                    <th class="table-info" colspan="2">{{
                                            $t('customers_club.event_details')
                                        }}
                                    </th>
                                </tr>
                                </thead>
                                <tbody id="event_detail">
                                </tbody>
                            </table>
                        </div>
                        <div style="display: none" id="gateway_details" class="modal-body mb-4">
                            <table class="table table-hover">
                                <thead id="table-header-gateway-details">
                                <tr>
                                    <th class="table-success" colspan="2">{{
                                            $t('label.gateway_detail')
                                        }}
                                    </th>
                                </tr>
                                </thead>
                                <tbody id="event_detail_gateway_details">
                                </tbody>
                            </table>
                        </div>
                        <div style="display: none" id="new_wage" class="modal-body mb-4">
                            <table class="table table-hover">
                                <thead id="table-header-new-wage">
                                <tr>
                                    <th class="table-info" colspan="2">{{
                                            $t('customers_club.new_wage_details')
                                        }}
                                    </th>
                                </tr>
                                </thead>
                                <tbody id="event_detail_new_wage">
                                </tbody>
                            </table>
                        </div>
                        <div style="display: none" id="old_wage" class="modal-body mb-4">
                            <table class="table table-hover">
                                <thead id="table-header-old_wage">
                                <tr>
                                    <th class="table-danger" colspan="2">{{
                                            $t('customers_club.old_wage_details')
                                        }}
                                    </th>
                                </tr>
                                </thead>
                                <tbody id="event_detail_old_wage">
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Vue from 'vue'
import $ from 'jquery'
import {i18n} from '@/plugins/i18n'
import {subjectTypeStr, subjectTypes} from '@/constants/UsersClubSubjectTypes'
import {terminalTypes,terminalTypeStr} from '@/constants/customersClubEventsTerminalTypes'
import {wageType, wageTypeStr} from '@/constants/WageTypes'
import {customerClubLevelStr} from '@/constants/userCustomerClubLevel'
import toastr from "toastr";
import {customersClubService} from "@/common/api.service";

export default Vue.extend({
    props: {
        row: {
            required: true,
        },
        index: {
            required: true,
        },
        datatable: {
            required: true,
        }
    },
    data() {
        return {
            subjectTypeStr,
            subjectTypes,
            wageType,
            wageTypeStr,
            customerClubLevelStr,
            terminalTypes,
            terminalTypeStr,
            isError:false,
            loading:false
        }
    },

    methods: {
     async appendDataToModal(row) {
         this.loading = true;
         await customersClubService.getEventDetails(this.row.id).then(({data}) => {
             this.row = data.data
         }).catch(() => {
             this.isError = true;
             this.toastr.error(i18n.t('message.an_error_accord'))
         }).finally(() => {
             this.loading = false;
         })
         if (this.isError)
             return;

            function simpleTextLtr(data, title) {
                return '<tr>' +
                        '<td style="width: 155px;">' + title + '</td>' +
                        '<td style="direction: ltr;">' + data + '</td>' +
                        '</tr>'
            }

            function currencyText(data, title){
                return '<tr><td style="width: 155px;">' + title + '</td>' +
                        '<td>' + data + ' ' + i18n.t('currency.rial') + '</td></tr>'
            }


            let title = $('#title').empty()
            let ps_elements =
                    '<h4 class="modal-title float-left p-0 m-0">' + i18n.t('label.description') + ' ' + this.row.id + '</h4>'
            title.append(ps_elements)

            ps_elements = ''
            if (this.row.subject === subjectTypes.LEVEL_CHANGE) {
                let event_detail = $('#event_detail').empty()
                document.getElementById('data_sheet').style.display = 'block';
                document.getElementById('new_wage').style.display = 'none';
                document.getElementById('old_wage').style.display = 'none';
                document.getElementById('gateway_details').style.display = 'none'
                ps_elements = simpleTextLtr(
                        i18n.t("customers_club.customers_club_level_change_from") + customerClubLevelStr.get(this.row.description.old_level) + ' ' +
                        i18n.t("customers_club.customers_club_level_change_to") + customerClubLevelStr.get(this.row.description.new_level)
                        , i18n.t("customers_club.level_change")
                )
                event_detail.append(ps_elements)
            } else if (this.row.subject === subjectTypes.WAGE_CHANGE) {

                document.getElementById('data_sheet').style.display = 'none';
                document.getElementById('new_wage').style.display = 'block';
                document.getElementById('old_wage').style.display = 'block';
                document.getElementById('gateway_details').style.display = 'block';

                //gateway_details
                let event_detail = $('#event_detail_gateway_details').empty()
                ps_elements = simpleTextLtr(terminalTypeStr.get(this.row.description.terminal_type)
                        , i18n.t("label.gateway_type")
                )
                event_detail.append(ps_elements)

                if (this.row.description.terminal_type == terminalTypes.PAYMENT_HELPER ||
                        this.row.description.terminal_type == terminalTypes.IVR) {
                    ps_elements = simpleTextLtr(this.row.description.shop_name
                            , i18n.t("label.gateway_title")
                    )
                    event_detail.append(ps_elements)
                }

                //old_wage
                event_detail = $('#event_detail_old_wage').empty()
                ps_elements = simpleTextLtr(wageTypeStr.get(this.row.description.old_wage_type)
                        , i18n.t("customers_club.wage_type")
                )
                event_detail.append(ps_elements)
                if (this.row.description.old_wage_type === wageType.FIXED || this.row.description.old_wage_type === wageType.PERIODIC) {
                    ps_elements = currencyText(this.row.description.old_wage_amount
                            , i18n.t("customers_club.wage_amount")
                    )
                    event_detail.append(ps_elements)
                } else if (this.row.description.old_wage_type === wageType.PERCENT) {
                    if (this.row.description.terminal_type != terminalTypes.PARDAKHT_SHAKHSI) {
                        ps_elements = simpleTextLtr(this.row.description.old_merchant_share_percent
                                , i18n.t("customers_club.merchant_share_percent")
                        )
                        event_detail.append(ps_elements)
                    }
                    ps_elements = currencyText(this.row.description.old_max_wage
                            , i18n.t("customers_club.max_wage_percent")
                    )
                    event_detail.append(ps_elements)
                    ps_elements = currencyText(this.row.description.old_min_wage
                            , i18n.t("customers_club.min_wage_percent")
                    )
                    event_detail.append(ps_elements)
                }

                ////new_wage
                event_detail = $('#event_detail_new_wage').empty()
                ps_elements = simpleTextLtr(wageTypeStr.get(this.row.description.new_wage_type)
                        , i18n.t("customers_club.wage_type")
                )
                event_detail.append(ps_elements)
                if (this.row.description.new_wage_type === wageType.FIXED || this.row.description.new_wage_type === wageType.PERIODIC) {
                    ps_elements = currencyText(this.row.description.new_wage_amount
                            , i18n.t("customers_club.wage_amount")
                    )
                    event_detail.append(ps_elements)
                } else if (this.row.description.new_wage_type === wageType.PERCENT) {
                    if (this.row.description.terminal_type != terminalTypes.PARDAKHT_SHAKHSI) {
                        ps_elements = simpleTextLtr(this.row.description.new_merchant_share_percent
                                , i18n.t("customers_club.merchant_share_percent")
                        )
                        event_detail.append(ps_elements)
                    }
                    ps_elements = currencyText(this.row.description.new_max_wage
                            , i18n.t("customers_club.max_wage_percent")
                    )
                    event_detail.append(ps_elements)
                    ps_elements = currencyText(this.row.description.new_min_wage
                            , i18n.t("customers_club.min_wage_percent")
                    )
                    event_detail.append(ps_elements)
                }
            }
        },
    },
    computed: {
        toastr() {
            toastr.options = {
                closeButton: true,
                positionClass: "toast-bottom-center",
                preventDuplicates: false,
                rtl: false
            }
            return toastr
        },
    }
})
</script>

<style>

</style>
